<template>
  <b-card no-body>
    <b-card-header>
      <b-card-sub-title><slot>{{ $vnode.key }}</slot></b-card-sub-title>
    </b-card-header>

    <b-card-body>
      <b-form-row class="mb-3">
        <b-col>
          <b-input 
            v-model="value.naam" 
            placeholder="Naam" 
            @input="$emit('input',value)"
          />
        </b-col>
        <b-col>
          <b-input 
            v-model="value.titel" 
            placeholder="Organisatie"
            @input="$emit('input',value)"
          />
        </b-col>
        <b-col />
      </b-form-row>
      <VueSignaturePad 
        :ref="$vnode.key" 
        :custom-style="{
          'border-radius': '3px',
          'background-color': '#dedede',
          border: 'gray 2px solid',
        }" 
        :options="{ onBegin, onEnd }" 
        width="500px" 
        height="250px" 
        @hook:mounted="
          $refs[$vnode.key].fromDataURL(value.png)
        "
      />

        
      <!-- <b-img 
      :src="value.png" 
      fluid />	 -->
      <b-button 
        class="mt-2"
        variant="danger"
        @click="clearSignature"
      >
        <font-awesome-icon icon="eraser" />
        Handtekening verwijderen
      </b-button>
    </b-card-body>
  </b-card>
</template>

<script>
import { VueSignaturePad } from "vue-signature-pad";
export default {
    name: 'Handtekening',
    components: {
        VueSignaturePad,
    },
    mixins: [],
    props: {
        names: {
            type: Array,
            default: () => []
        },
        value: {
            type: Object,
            default: () => {
                return {
                    naam: '',
                    titel: '',
                    png: null
                }
            }
        }
    },
    data() {
        return {

        }
    },
    computed: {
        hasSignature() {
            return this.value.png !== null;
        },
    },
    watch: {},
    mounted() {

    },
    methods: {
        onBegin(event) {
            console.log("onEnd", event);
            //this.previewSignature();
        },
        onEnd(event) {
            console.log("onEnd", event);
            this.previewSignature();
        },
        previewSignature() {
            this.value.png =this.$refs[this.$vnode.key].saveSignature().data;
            this.$emit('input', this.value);
        },
        clearSignature() {
            this.$refs[this.$vnode.key].clearSignature();
            this.previewSignature();
        },
    },

}
</script>
